<template>
  <div>
    <shared-view-consultation-by-company-name></shared-view-consultation-by-company-name>
  </div>
</template>

<script>
import SharedViewConsultationByCompanyName from '@/views/Shared/Consultations/Company/List'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Consultation.Company.List',
  components: {
    SharedViewConsultationByCompanyName
  },
  mounted () {
    EventBus.$emit('loadConsultationByCompanyName', this.$route.params.companyName)
  }
}
</script>

<style scoped>

</style>
